<template>
  <el-upload class="au-upload" drag :multiple="multiple" action="" :auto-upload="false" :show-file-list="false"
    :accept="accept" :on-change="onChange">
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
  </el-upload>
</template>

<script>
/**
 * @description 文件上传
 * @created 2024/04/27 10:17:20
 */
export default {
  name: "AuUpload",
  props: {
    accept: {
      type: String,
      default: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onChange(file, fileList) {
      this.$emit("change", file, fileList)
    }
  }
}
</script>

<style lang="scss" scoped>
.au-upload {}
</style>
